module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "anchor-help-center"
  }, [_c('xi-top'), _vm._v(" "), _c('div', {
    staticClass: "center-wrapper"
  }, [_c('div', {
    staticClass: "center-menu-wrapper"
  }, [_c('router-link', {
    staticClass: "center-menu-item",
    class: {
      'top-menu-chosen': _vm.menuIndex === 0
    },
    attrs: {
      "to": {
        name: 'anchorAboutPlatform'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.menuIndex = 0;
        _vm.showSub = false;
      }
    }
  }, [_c('div', {
    staticClass: "sticker"
  }), _c('i', {
    staticClass: "icon icon-20 icon-help-center-about-platform"
  }), _c('span', [_vm._v("了解平台")])]), _vm._v(" "), _c('router-link', {
    staticClass: "center-menu-item",
    class: {
      'top-menu-chosen': _vm.menuIndex === 1
    },
    attrs: {
      "to": {
        name: 'beAnAnchor'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.menuIndex = 1;
        _vm.showSub = false;
      }
    }
  }, [_c('div', {
    staticClass: "sticker"
  }), _c('i', {
    staticClass: "icon icon-20 icon-help-center-be-an-anchor"
  }), _c('span', [_vm._v("成为主播")])]), _vm._v(" "), _c('router-link', {
    staticClass: "center-menu-item",
    class: {
      'top-menu-chosen': _vm.menuIndex === 8
    },
    attrs: {
      "to": {
        name: 'anchorLevelTips'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.menuIndex = 8;
        _vm.showSub = false;
      }
    }
  }, [_c('div', {
    staticClass: "sticker"
  }), _c('i', {
    staticClass: "icon icon-20 icon-help-center-anchor-level"
  }), _c('span', [_vm._v("主播等级")])]), _vm._v(" "), _c('router-link', {
    staticClass: "center-menu-item",
    class: {
      'top-menu-chosen': _vm.menuIndex === 2
    },
    attrs: {
      "to": {
        name: 'searchTask'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.menuIndex = 2;
        _vm.showSub = false;
      }
    }
  }, [_c('div', {
    staticClass: "sticker"
  }), _c('i', {
    staticClass: "icon icon-20 icon-help-center-task"
  }), _c('span', [_vm._v("寻找任务")])]), _vm._v(" "), _c('router-link', {
    staticClass: "center-menu-item",
    class: {
      'top-menu-chosen': _vm.menuIndex === 3
    },
    attrs: {
      "to": {
        name: 'auditionTips'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.menuIndex = 3;
        _vm.showSub = true;
        _vm.subMenuIndex = -1;
      }
    }
  }, [_c('div', {
    staticClass: "sticker"
  }), _c('i', {
    staticClass: "icon icon-20 icon-help-center-tips"
  }), _c('span', [_vm._v("试音技巧")])]), _vm._v(" "), (_vm.showSub) ? _c('div', [_c('router-link', {
    staticClass: "center-menu-sub-item",
    class: {
      'sub-menu-chosen': _vm.subMenuIndex === 0
    },
    attrs: {
      "to": {
        name: 'pickEquipment'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.menuIndex = 3;
        _vm.subMenuIndex = 0;
      }
    }
  }, [_c('span', [_vm._v("录音设备挑选")])]), _vm._v(" "), _c('router-link', {
    staticClass: "center-menu-sub-item",
    class: {
      'sub-menu-chosen': _vm.subMenuIndex === 1
    },
    attrs: {
      "to": {
        name: 'announceTips'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.menuIndex = 3;
        _vm.subMenuIndex = 1;
      }
    }
  }, [_c('span', [_vm._v("有声播讲技巧")])]), _vm._v(" "), _c('router-link', {
    staticClass: "center-menu-sub-item",
    class: {
      'sub-menu-chosen': _vm.subMenuIndex === 2
    },
    attrs: {
      "to": {
        name: 'audioPostProgress'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.menuIndex = 3;
        _vm.subMenuIndex = 2;
      }
    }
  }, [_c('span', [_vm._v("音频后期处理")])])], 1) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "center-menu-item",
    class: {
      'top-menu-chosen': _vm.menuIndex === 4
    },
    attrs: {
      "to": {
        name: 'recordDemand'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.menuIndex = 4;
        _vm.showSub = false;
      }
    }
  }, [_c('div', {
    staticClass: "sticker"
  }), _c('i', {
    staticClass: "icon icon-20 icon-hlep-center-requirement"
  }), _c('span', [_vm._v("录制要求")])]), _vm._v(" "), _c('router-link', {
    staticClass: "center-menu-item",
    class: {
      'top-menu-chosen': _vm.menuIndex === 5
    },
    attrs: {
      "to": {
        name: 'anchorDataAnalysis'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.menuIndex = 5;
        _vm.showSub = false;
      }
    }
  }, [_c('div', {
    staticClass: "sticker"
  }), _c('i', {
    staticClass: "icon icon-20 icon-help-center-data"
  }), _c('span', [_vm._v("数据分析")])]), _vm._v(" "), _c('router-link', {
    staticClass: "center-menu-item",
    class: {
      'top-menu-chosen': _vm.menuIndex === 6
    },
    attrs: {
      "to": {
        name: 'popularize'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.menuIndex = 6;
        _vm.showSub = false;
      }
    }
  }, [_c('div', {
    staticClass: "sticker"
  }), _c('i', {
    staticClass: "icon icon-20 icon-help-center-broadcast"
  }), _c('span', [_vm._v("推广")])]), _vm._v(" "), _c('router-link', {
    staticClass: "center-menu-item",
    class: {
      'top-menu-chosen': _vm.menuIndex === 7
    },
    attrs: {
      "to": {
        name: 'earningClosing'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.menuIndex = 7;
        _vm.showSub = false;
      }
    }
  }, [_c('div', {
    staticClass: "sticker"
  }), _c('i', {
    staticClass: "icon icon-20 icon-help-center-gain"
  }), _c('span', [_vm._v("收益结算")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "center-right"
  }, [_c('router-view')], 1)]), _vm._v(" "), _c('xi-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0278dd68!./~/vue-loader/lib/selector.js?type=template&index=0!./views/anchor/helpCenter/AnchorHelpCenter.vue
// module id = 343
// module chunks = 0